import { cn } from "@/lib/utils";
import { TrendingUp, TrendingDown } from "lucide-react";

export function KpiCard({ label, value, icon: Icon, trend, tone = "accent", testId, onClick }) {
  const tones = {
    accent: "bg-accent/10 text-accent",
    warning: "bg-amber-500/10 text-amber-600 dark:text-amber-400",
    danger: "bg-red-500/10 text-red-600 dark:text-red-400",
    info: "bg-sky-500/10 text-sky-600 dark:text-sky-400",
  };
  return (
    <button
      type="button"
      onClick={onClick}
      data-testid={testId}
      className={cn(
        "group flex flex-col justify-between rounded-lg border border-border bg-card p-4 text-left shadow-sm transition-colors hover:border-accent/40",
        onClick ? "cursor-pointer" : "cursor-default"
      )}
    >
      <div className="flex items-start justify-between">
        <span className="text-xs font-medium uppercase tracking-wide text-muted-foreground">{label}</span>
        {Icon && <span className={cn("rounded-md p-1.5", tones[tone])}><Icon className="h-4 w-4" /></span>}
      </div>
      <div className="mt-3 flex items-end gap-2">
        <span className="text-2xl font-semibold tracking-tight text-foreground">{value}</span>
        {trend != null && (
          <span className={cn("mb-1 inline-flex items-center gap-0.5 text-xs font-medium",
            trend >= 0 ? "text-emerald-600 dark:text-emerald-400" : "text-red-600 dark:text-red-400")}>
            {trend >= 0 ? <TrendingUp className="h-3 w-3" /> : <TrendingDown className="h-3 w-3" />}
            {Math.abs(trend)}%
          </span>
        )}
      </div>
    </button>
  );
}
